import React from 'react';
import { LayoutContentHeader } from '@pinwheel/origami';
import useJobForm from '../hooks/useJobForm';
import TemplateForm from '../components/TemplateForm/TemplateForm';
import { TextListItems } from '../components/TextListItems';
import JobFormError from './JobFormError';
/**
 * This component is used to display a Link API response with a "form" template type.
 *
 * NOTE: Little to no logic should be written inside this component. This component
 * should merely choose which view to show based on the results of the main React hook.
 */
var JobForm = function (_a) {
    var onSubmit = _a.onSubmit, linkApiResponse = _a.linkApiResponse, extraControlsTop = _a.extraControlsTop, extraControlsBottom = _a.extraControlsBottom;
    var _b = useJobForm(linkApiResponse.template), title = _b.title, subtitle = _b.subtitle, textList = _b.textList, actions = _b.actions, initialValues = _b.initialValues;
    return (React.createElement(TemplateForm, { fieldConfigs: linkApiResponse.template.fields, onSubmit: onSubmit, extraControlsTop: extraControlsTop, extraControlsBottom: extraControlsBottom, actions: linkApiResponse.template.actions.concat(actions), submitButtonText: linkApiResponse.template.buttonText, submitButtonEventId: linkApiResponse.responseType === 'next_with_error'
            ? 'JobForm-retry'
            : 'JobForm-continue', initialValues: initialValues },
        React.createElement(LayoutContentHeader, { title: title, subtitle: subtitle }),
        textList && (React.createElement("ul", { "data-testid": "templateForm__list", className: "templateForm__list", style: {
                textAlign: 'left',
            } },
            React.createElement(TextListItems, { textList: textList }))),
        React.createElement(JobFormError, { linkApiResponse: linkApiResponse, onSubmit: onSubmit })));
};
export default JobForm;
